// extracted by mini-css-extract-plugin
export default {"productcard":"UN","productimage":"VN","username":"WN","multiBagName":"XN","productinfo":"YN","productinfoinner":"ZN","productname":"aO","productsubheader":"bO","productdescription":"cO","productnumbers":"eO","productnumberstitle":"fO","productnumbersitem":"gO","number":"hO","numbertext":"iO","tabs":"jO","benefitsblock":"kO","benefit":"lO","benefitname":"mO","benefitdescription":"nO","ingredientsblock":"oO","tipsblock":"pO","mobileonly":"qO"};
    if(module.hot) {
      // 1730991509029
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  